import PropTypes from "prop-types";
import React from "react";
import { Button } from "react-bootstrap";
import { Box } from "view/layout/box";
import * as FeatureFlags from 'redux-store/feature-flags/selectors';

class ScreenshotBox extends React.PureComponent {
  static get propTypes() {
    return {
      device: PropTypes.object.isRequired,
      isChromeOS: PropTypes.bool.isRequired,
      featureFlags: PropTypes.object,
      online: PropTypes.bool.isRequired,
      takeScreenshot: PropTypes.func.isRequired,
      takeWebcamSnapshot: PropTypes.func.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      message: "",
      refreshing: false,
      screenshot: "",
    };

    this._takeScreenshot = this._takeScreenshot.bind(this);
    this._takeWebcamSnapshot = this._takeWebcamSnapshot.bind(this);
  }

  _webcamSnapshotsEnabled() {
    if (!this.props.featureFlags) {
      return false;
    }
    return this.props.featureFlags['enable-webcam-snapshots'] || false;
  }

  _fetchScreenshot() {
    const { device, takeScreenshot } = this.props;

    return takeScreenshot(device.id)
      .then((res) => {
        const { data = {} } = res.data;
        this.setState({
          screenshot: data.screenshot,
          refreshing: false,
          message: "",
        });
      })
      .catch((e) => {
        this.setState({
          screenshot: "",
          refreshing: false,
          message: "Device screenshot is not available at the moment.",
        });
      });
  }

  _fetchWebcamSnapshot() {
    const { device, takeWebcamSnapshot } = this.props;

    return takeWebcamSnapshot(device.device_id)
      .then((res) => {
        const { data = {} } = res.data;
        this.setState({
          screenshot: data.snapshot,
          refreshing: false,
          message: "",
        });
      })
      .catch((e) => {
        this.setState({
          screenshot: "",
          refreshing: false,
          message: "Device snapshot is not available at the moment.",
        });
      });
  }

  _takeScreenshot() {
    this.setState(
      {
        refreshing: true,
        message: "",
      },
      this._fetchScreenshot,
    );
  }

  _takeWebcamSnapshot() {
    this.setState(
      {
        refreshing: true,
        message: "",
      },
      this._fetchWebcamSnapshot,
    );
  }

  render() {
    const { online } = this.props;
    const offlineClass = online ? "" : "offline";

    return (
      <Box
        title="Device Screenshot"
        className={`online-component ${offlineClass}`}
        toolbox={this._renderToolbox()}
      >
        {this._renderScreenshot()}
      </Box>
    );
  }

  _renderScreenshot() {
    const { online, isChromeOS } = this.props;
    const { screenshot, message } = this.state;
    const offlineMsg = online ? "" : "Device is currently offline";
    const chromeosMsg = isChromeOS
      ? "Screenshot feature not available on ChromeOS devices."
      : "";

    if (screenshot) {
      return (
        <div className="screenshot">
          <img src={screenshot} />
          <div className="screenshot-status-text">{offlineMsg}</div>
        </div>
      );
    }

    return (
      <div className="screenshot-na bg-blue">
        {chromeosMsg || offlineMsg || message}
      </div>
    );
  }

  _renderToolbox() {
    const { online, isChromeOS } = this.props;
    const { refreshing } = this.state;

    return (
      <div>
        { this._webcamSnapshotsEnabled() &&
          <Button
            size="sm"
            variant="primary"
            disabled={!online || refreshing || isChromeOS}
            className="snapshot-button"
            onClick={this._takeWebcamSnapshot}
            style={{marginRight: "5px"}}
          >
            <i className="fa fa-2x fa-dot-circle-o" />
          </Button>
        }
        <Button
          size="sm"
          variant="danger"
          onClick={this._takeScreenshot}
          disabled={!online || refreshing || isChromeOS}
          className="screenshot-button"
        >
          <i className="fa fa-2x fa-camera" />
        </Button>
      </div>
    );
  }
}

export { ScreenshotBox };
